// extracted by mini-css-extract-plugin
export default {"the_localization":"TheLocalization_styles_the_localization__HwLqH"};